interface SparklineProps {
  data: number[];
  color?: string;
  width?: number;
  height?: number;
}

export function Sparkline({ data, color = "var(--color-accent)", width = 56, height = 16 }: SparklineProps) {
  if (!data || data.length === 0) return null;

  const max = Math.max(...data, 1);
  const barCount = data.length;
  const gap = 2;
  const barWidth = (width - gap * (barCount - 1)) / barCount;

  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`}>
      {data.map((value, i) => {
        const barHeight = Math.max((value / max) * height, value > 0 ? 2 : 0);
        const opacity = value > 0 ? 0.15 + (value / max) * 0.55 : 0;
        const x = i * (barWidth + gap);
        const y = height - barHeight;
        return (
          <rect
            key={i}
            x={x}
            y={y}
            width={barWidth}
            height={barHeight}
            fill={color}
            opacity={opacity}
            rx={1}
          />
        );
      })}
    </svg>
  );
}
